import { render, staticRenderFns } from "./questionBank.vue?vue&type=template&id=7bd1832a&scoped=true&"
import script from "./questionBank.vue?vue&type=script&lang=js&"
export * from "./questionBank.vue?vue&type=script&lang=js&"
import style0 from "./questionBank.vue?vue&type=style&index=0&id=7bd1832a&prod&lang=scss&"
import style1 from "./questionBank.vue?vue&type=style&index=1&id=7bd1832a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd1832a",
  null
  
)

export default component.exports